import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { StepStatus } from '~/enums';
import { RootState } from '~/store';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { patchApplication } from '~/store/actions/loanApplicationActions';
import useStepConfig from './useStepConfig';
import { marketHasCheckpointStep } from '~/constants/markets';

const useGoToNextStep = () => {
  const dispatch = useAppDispatch();
  const { isLastBasicStep } = useStepConfig();
  const { market } = useSelector((state: RootState) => state.intl);

  const onNextStepClick = useCallback(async () => {
    try {
      dispatch(pushToGtmLoanAction({ actionName: 'next_button_pressed' }));
      const choseToSubmitBasicApplication =
        marketHasCheckpointStep[market] && isLastBasicStep;

      await dispatch(patchApplication({ choseToSubmitBasicApplication }));
    } catch (_err: any) {
      dispatch(
        pushToGtmLoanAction({
          stepStatus: StepStatus.Error,
          errorMessage: _err.response?.data?.message,
        })
      );
    }
  }, [dispatch, isLastBasicStep]);

  return onNextStepClick;
};

export default useGoToNextStep;
